import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface LikeIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const LikeIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: LikeIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <rect
                x="3.7774"
                y="10.6535"
                width="3"
                height="8"
                rx="0.5"
                stroke={color}
                strokeWidth={2}
            />
            <path
                d="M19.76 10.7017L17.2885 17.8005C17.1486 18.2024 16.7697 18.4717 16.3441 18.4717H10.1693C9.61697 18.4717 9.16925 18.024 9.16925 17.4717V10.3174C9.16925 10.0982 9.24123 9.88516 9.37413 9.71092L13.0584 4.88047C13.2199 4.66873 13.519 4.62072 13.7387 4.77128L15.1094 5.71083C15.3013 5.84242 15.3771 6.08909 15.2922 6.30578L14.6247 8.00786C14.3674 8.66379 14.8511 9.37295 15.5556 9.37295H18.8156C19.5037 9.37295 19.9862 10.0518 19.76 10.7017Z"
                stroke={color}
                strokeWidth={2}
            />
        </svg>
    )
}

export default LikeIcon
